import axios from 'axios';
import { User } from "../../types";
import Cookies from 'js-cookie';
import api from '../../services/api';

export interface LoginResponse {
    user: User;
    accessToken: string;
    refreshToken: string;
  }
  
  export async function login(username: string, password: string): Promise<LoginResponse> {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });
  
    if (!response.ok) {
      throw new Error("Login failed");
    }
  
    return response.json();
  }
  
  // Forgot Password function
export async function forgotPassword(email: string): Promise<void> {
  const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/forgot-password`, {
    email ,
  });

  if (response.status !== 201) {
    throw new Error("Forgot password failed");
  }
}

export async function resetPassword(password: string, token: string): Promise<void> {
  try {
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/reset-password`, {
      password,
      token
    });
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || 'Failed to reset password.'
    );
  }
}

const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000/api';

export const refreshToken = async () => {
  try {
    // Get the refresh token from cookies.
    const refreshTokenCookie = Cookies.get('refreshToken');
    if (!refreshTokenCookie) {
      throw new Error('No refresh token available');
    }

    // Create a new axios instance that does NOT use the global interceptor (which attaches the access token).
    const refreshApi = axios.create({
      baseURL: REACT_APP_API_BASE_URL,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const response = await refreshApi.get('/auth/refresh-token', {
      headers: {
        Authorization: `Bearer ${refreshTokenCookie}`,
      },
    });

    const data = response.data;
    // Expect data to include new tokens and expiry information:
    // { accessToken, refreshToken, tokenExpiry }
    Cookies.set('accessToken', data.accessToken, { secure: true, sameSite: 'strict' });
    Cookies.set('refreshToken', data.refreshToken, { secure: true, sameSite: 'strict' });
    Cookies.set('tokenExpiry', data.tokenExpiry, { secure: true, sameSite: 'strict' });
    
    return data;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    throw error;
  }
};